import React, { useState } from "react";
import { Button, Snackbar, Alert } from "@mui/material";
import { ContentCopy } from "@mui/icons-material";
import { 
  ContainerBox, 
  DataTitle, 
  SingleDataCard,
  DataSubtitle,
  DataRow,
  DataGroup,
  DataLabel,
  DataValue,
  CopyButton,
  UserDataBlock,
  UserHeader,
  IndividualCopyButton
} from "./styles";

export const DataAccess = ({ users }) => {
  const [showCopyAlert, setShowCopyAlert] = useState(false);

  const handleCopyAllData = async () => {
    let dataToCopy = "DADOS DE ACESSO\n\n";
    
    users.forEach((user, index) => {
      dataToCopy += `${user.Nome}\n`;
      dataToCopy += `Usuário: ${user.login}\n`;
      dataToCopy += `Senha: ${user.password}\n`;
      if (index < users.length - 1) {
        dataToCopy += "\n";
      }
    });
    
    try {
      await navigator.clipboard.writeText(dataToCopy);
      setShowCopyAlert(true);
    } catch (err) {
      console.error('Erro ao copiar dados:', err);
      // Fallback para navegadores mais antigos
      const textArea = document.createElement('textarea');
      textArea.value = dataToCopy;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      setShowCopyAlert(true);
    }
  };

  const handleCopyIndividualData = async (user) => {
    const dataToCopy = `${user.Nome}\nUsuário: ${user.login}\nSenha: ${user.password}`;
    
    try {
      await navigator.clipboard.writeText(dataToCopy);
      setShowCopyAlert(true);
    } catch (err) {
      console.error('Erro ao copiar dados:', err);
      // Fallback para navegadores mais antigos
      const textArea = document.createElement('textarea');
      textArea.value = dataToCopy;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      setShowCopyAlert(true);
    }
  };

  return (
    <ContainerBox>
      <DataTitle>Dados de Acesso</DataTitle>
      <SingleDataCard>
        <CopyButton>
          <Button
            variant="contained"
            startIcon={<ContentCopy />}
            onClick={handleCopyAllData}
            sx={{
              backgroundColor: '#1976d2',
              '&:hover': {
                backgroundColor: '#1565c0',
              },
              textTransform: 'none',
              fontWeight: 'bold',
            }}
          >
            Copiar Todos os Dados
          </Button>
        </CopyButton>
        
        {users.map((user, key) => (
          <UserDataBlock key={key}>
            <UserHeader>
              <DataSubtitle>{user.Nome}</DataSubtitle>
              <IndividualCopyButton
                onClick={() => handleCopyIndividualData(user)}
                title="Copiar dados deste usuário"
              >
                <ContentCopy fontSize="small" />
              </IndividualCopyButton>
            </UserHeader>
            <DataRow>
              <DataGroup>
                <DataLabel>Usuário:</DataLabel>
                <DataValue>{user.login}</DataValue>
              </DataGroup>
              <DataGroup>
                <DataLabel>Senha:</DataLabel>
                <DataValue>{user.password}</DataValue>
              </DataGroup>
            </DataRow>
          </UserDataBlock>
        ))}
      </SingleDataCard>
      
      <Snackbar
        open={showCopyAlert}
        autoHideDuration={3000}
        onClose={() => setShowCopyAlert(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert 
          onClose={() => setShowCopyAlert(false)} 
          severity="success"
          sx={{ width: '100%' }}
        >
          Todos os dados copiados para a área de transferência!
        </Alert>
      </Snackbar>
    </ContainerBox>
  );
};
